import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ApiService} from './services/api.service';
import { PhoneCountrySelectComponent } from './components/phone-country-select/phone-country-select.component';
import { NgxSatorisModule } from 'ngx-satoris';
import {DateFormatPipe} from './pipes/date-format.pipe';

@NgModule({
  imports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSatorisModule
  ],
  exports: [
    PhoneCountrySelectComponent,
    DateFormatPipe
  ],
  declarations: [
    PhoneCountrySelectComponent,
    DateFormatPipe
  ],
  providers: [
    ApiService
  ]
})
export class SharedModule {
}
